import React, { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import routers from "./router";
import { Helmet, HelmetProvider } from "react-helmet-async";
import LoadingDom from "./components/UI/LoadingDom";
import LoadingGIF from "./components/UI/LoadingGIF";
import appStore from "@/stores/appStore";
import "animate.css";
import "@/style/font-awesome/css/font-awesome.css";

const App: React.FC = () => {
  const element = useRoutes(routers);
  return (
    <HelmetProvider>
      <React.Fragment>
        <Helmet></Helmet>
        <React.Fragment>
          <Suspense
            fallback={
              !appStore.isOdm ? (
                <LoadingDom isLoading>
                  <div style={{ width: "100vw", height: "100vh" }}></div>
                </LoadingDom>
              ) : (
                <div
                  style={{
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <LoadingGIF />
                </div>
              )
            }
          >
            {element}
          </Suspense>
        </React.Fragment>
      </React.Fragment>
    </HelmetProvider>
  );
};

export default App;
